import {Injectable} from '@angular/core';
import {SelectionService} from '@app/selection/selection.service';

import {Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

import {Asset, AssetService} from '../asset';

@Injectable({
    providedIn: 'root',
})
export class InspectorService {
    public asset: Subject<Asset>;
    private _asset: Asset;

    constructor(
        private assetService: AssetService,
        private selectionService: SelectionService,
    ) {
        this._asset = null;
        this.asset = new Subject<Asset>();
        this.assetService.assetUpdated
            .pipe(filter((asset) => Boolean(this._asset) && asset.id === this._asset.id))
            .subscribe((asset) => this.inspect(asset));
        this.selectionService.selectionMode
            .pipe(filter((value) => value))
            .subscribe(() => this.inspect(null));
    }

    inspect(asset: Asset) {
        this._asset = asset;
        this.asset.next(this._asset);
    }

    get isInspecting(): boolean {
        return this._asset !== null;
    }
}
